import React from 'react';
import { Link } from 'react-router-dom';
import { trustOrgs } from '../../data/casinos';
import './TrustSection.css';

export default function TrustSection() {
  return (
    <section className="trust-section section bg-mesh-sand">
      <div className="container">
        <div className="trust-header">
          <div className="divider"></div>
          <h2>Spilsikkerhed & Spillerbeskyttelse i Danmark</h2>
          <p className="section-subtitle">
            Alle casinoer, vi omtaler, er licenseret af Spillemyndigheden. Vi støtter aktivt ansvarligt spil
            og informerer om de redskaber, der er tilgængelige for danske spillere.
          </p>
        </div>

        <div className="trust-orgs-grid">
          {trustOrgs.map((org) => (
            <a
              key={org.id}
              href={org.url}
              target="_blank"
              rel="noopener noreferrer"
              className="trust-org-card"
            >
              <div className="trust-org-logo-wrap">
                <img src={org.logo} alt={org.name} className="trust-org-logo" />
              </div>
              <div className="trust-org-info">
                <h4>{org.name}</h4>
                <p>{org.description}</p>
                <span className="trust-org-link-label">Besøg {org.name} →</span>
              </div>
            </a>
          ))}
        </div>

        <div className="trust-tools-grid">
          <div className="trust-tool-item">
            <div className="trust-tool-icon">🔒</div>
            <div>
              <h5>ROFUS Selvudelukkelse</h5>
              <p>Registrér dig frivilligt og udeluk dig fra alle danske spilsider med ét klik.</p>
            </div>
          </div>
          <div className="trust-tool-item">
            <div className="trust-tool-icon">💬</div>
            <div>
              <h5>Gratis Rådgivning</h5>
              <p>StopSpillet tilbyder anonym og gratis hjælp til spillere og pårørende – ring 70 22 28 25.</p>
            </div>
          </div>
          <div className="trust-tool-item">
            <div className="trust-tool-icon">📋</div>
            <div>
              <h5>Dansk Licens Krav</h5>
              <p>Det er ulovligt at udbyde spil til danskere uden dansk licens fra Spillemyndigheden.</p>
            </div>
          </div>
          <div className="trust-tool-item">
            <div className="trust-tool-icon">⏱️</div>
            <div>
              <h5>Tids- & Udgiftsgrænser</h5>
              <p>Sæt daglige, ugentlige eller månedlige grænser direkte på casinoets konto.</p>
            </div>
          </div>
        </div>

        <div className="trust-cta-bar">
          <span>Er spil ved at blive et problem?</span>
          <Link to="/ansvarligt-spil" className="btn btn-outline">Læs vores guide til ansvarligt spil</Link>
          <a href="https://www.stopspillet.dk/" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
            Få hjælp på StopSpillet.dk
          </a>
        </div>
      </div>
    </section>
  );
}
